import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {EpiImage} from "features/search/types";
import {IContentBlock} from 'features/blocks/types';
import {ImageSizes} from '@organisms/Shell/image-size-enum';
import {HeadlineLevel, Margin, ParagraphSize} from 'features/ui/enums';
import {useDeviceStore, selectIsMobile, selectIsTablet} from 'features/ui/store/useDeviceStore';

import 'components/blocks/Headers/CtaHeaderBlock/style.scss';

import {P} from '@atoms/Text/P';
import {Headline} from '@atoms/Text/Headline';
import {Container} from '@atoms/Layout/Container';
import {AsyncImage} from '@atoms/Media/AsyncImage';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

export interface CtaHeaderBlockType {
    heroImage: EpiImage;
    title: string;
    preamble: string;
    buttonLink: string;
    buttonText: string;
    orangeButton: boolean;
    internalLink: boolean;
}

type Props = IContentBlock<CtaHeaderBlockType>;

export const CtaHeaderBlock: React.FunctionComponent<Props> = (props) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);

    if(!props.data.heroImage || props.data.heroImage === null) return null;
    return (
        <div className="cta-header-block" id={props.id}>
            <div className="cta-header-block__image">
                <div className="cta-header-block__image__wrapper">
                    <AsyncImage
                        image={props.data.heroImage}
                        headerImage
                        quality={ImageSizes.SIZE_2560}
                        //alt={props.data.title}
                    />
                </div>
            </div>

            {props.data.title &&
                <div className="cta-header-block__text">
                    <Container narrow className="cta-header-block__header">
                        <Headline 
                            level={HeadlineLevel.H1} 
                            margin={isMobile && !isTablet ? Margin.S : undefined}
                            center
                            darkBg
                        >
                            {props.data.title}
                        </Headline>
                        {!isMobile && <P center size={ParagraphSize.L} className="dark-bg">{props.data.preamble}</P>}
                        {props.data.buttonLink &&
                            <ButtonLink 
                                href={props.data.buttonLink} 
                                forceExternal={!props.data.internalLink} 
                                buttonColor={props.data.orangeButton
                                    ? ButtonColor.CTA
                                    : ButtonColor.LIGHT} 
                                buttonSize={ButtonSize.WIDE} 
                                buttonType={props.data.orangeButton
                                    ? ButtonType.DEFAULT
                                    : ButtonType.GHOST} 
                            >
                                {props.data.buttonText ?
                                    props.data.buttonText :
                                    <FormattedMessage id="jm.components.organisms.ctaHeaderBlock.readMore" />
                                }
                            </ButtonLink>
                        }

                    </Container>
                </div>
            }
        </div>
    );
};

